module.exports = __webpack_public_path__ + "static/media/16_c_1.b7b850d8.png";